import { render, staticRenderFns } from "./supervise_addAndedit.vue?vue&type=template&id=59d9f1c6&scoped=true"
import script from "./supervise_addAndedit.vue?vue&type=script&lang=js"
export * from "./supervise_addAndedit.vue?vue&type=script&lang=js"
import style0 from "./supervise_addAndedit.vue?vue&type=style&index=0&id=59d9f1c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d9f1c6",
  null
  
)

export default component.exports